<template>
  <div>
    <span class="subtitle-2 px-1">{{ $vuetify.lang.t('$vuetify.map.criticalPopup.criticalVideo.title') }}</span>
    <v-row justify="center" align-content="center" class="text-center">
      <v-col md="1" cols="12">
        <v-btn icon @click="sendSignal">
          <v-icon large>{{ buttonIcon }}</v-icon>
        </v-btn>
      </v-col>
      <v-col md="11" cols="12" class="px-2 mx-0">
        <v-slider v-model="value" min="0" :max="maxDuration">
          <template v-slot:append>
            <span class="mr-2 py-1">{{ value }}</span>
          </template>
        </v-slider>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import { mdiPlayCircle, mdiStopCircle } from '@mdi/js'
import { defaultCriticalVideoDuration, videoSeekSeconds } from '@/utils/time'
import { syncSliderMode } from '@/enum'

export default {
  name: 'criticalVideoSyncSlider',
  props: {
    driverDuration: {
      type: Number,
      default: 0
    },
    roadDuration: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    state: syncSliderMode.STOP,
    playIcon: mdiPlayCircle,
    stopIcon: mdiStopCircle,
    value: videoSeekSeconds
  }),
  computed: {
    maxDuration () {
      return Math.max(defaultCriticalVideoDuration, this.driverDuration, this.roadDuration)
    },
    buttonIcon () {
      return this.state === syncSliderMode.STOP ? this.playIcon : this.stopIcon
    }
  },
  methods: {
    sendSignal () {
      const signal = this.state === syncSliderMode.STOP ? 'play-all-video' : 'stop-all-video'
      this.$emit(signal)

      if (this.state === syncSliderMode.STOP) {
        this.state = syncSliderMode.PLAY
      } else {
        this.state = syncSliderMode.STOP
      }
    },
    resetState () {
      this.state = syncSliderMode.STOP
    }
  },
  watch: {
    value (newValue) {
      if (this.state === syncSliderMode.PLAY) {
        this.sendSignal() // stop all video
      }

      this.$emit('duration-changed', newValue)
    }
  }
}
</script>

<style scoped>

</style>
